module.exports = __webpack_public_path__ + "img/Fav_default.e08d23e0.png";